import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import NotificationSystem from "./components/feature/NotificationSystem";
import { useState, useEffect } from "react";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = () => {
      const authStatus = sessionStorage.getItem('dashboard_auth');
      setIsAuthenticated(authStatus === 'authenticated');
    };

    checkAuth();

    // Listen for auth changes
    const interval = setInterval(checkAuth, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <NotificationSystem isAuthenticated={isAuthenticated} />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
